<template>
<div class="chapter">
<div class="inner_page">
<p class="p1"><span class="t1">Readers love </span><span class="t1"><br/></span><span class="t2">J</span><span class="t3">OHN</span><span class="t2"> S</span><span class="t3">IMPSON</span></p>
<p class="p2"><span class="t4">Badges</span></p>
<p class="p3"><span class="t0">“If you enjoy M/M relationships, this is a very well written book and I recommend it highly.”</span></p>
<p class="p4"><span class="t0">—</span><span class="t0">The Romance Studio</span></p>
<p class="p5">“…an entertaining read where all of the characters are engaging and likable”</p>
<p class="p6">—Blackraven Reviews</p>
<p class="p6"><span class="t4">The Beach House</span></p>
<p class="p5">“John Simpson tells a touching story of two men damaged by loss trying to go on with their lives.”</p>
<p class="p4">—Sensual Reads</p>
<p class="p6"><span class="t4">Alex and Clayton</span></p>
<p class="p5">“I’d give this a definite A for good clean storytelling, characters that I liked and appreciated without casting judgment on their pasts<span class="t6"> and</span> for keeping it basically between the relationship of Alex and Clayton as the title suggests.”</p>
<p class="p4">—MM Good Book Reviews</p>
<p class="p2"><span class="t4">Naval Maneuvers</span></p>
<p class="p7"><span class="t0">“…a refreshing and honest view of military life and the problems gay men may face is intriguing and enthralling.”</span></p>
<p class="p4"><span class="t0">—</span><span class="t0">Manic Readers</span></p>
<p class="p2"><span class="t4">Condor One</span></p>
<p class="p7"><span class="t0">“…a brilliant story of ‘what if’ and one I highly recommend.”</span></p>
<p class="p4"><span class="t0">—</span><span class="t0">Literary Nymphs</span></p>
<p class="p7"><span class="t0">“If you like books with thrill-a-minute plots, stories about political wrangling, and tales with sexy men falling in love, then may I suggest you look no further than John Simpson and Condor One. What a rush!”</span></p>
<p class="p4"><span class="t0">—</span><span class="t0">Dark Divas Recommended Read</span></p>
<p class="p2"><span class="t4">Talons of the Condor</span></p>
<p class="p7"><span class="t0">“…a definite page-turner.”</span></p>
<p class="p4"><span class="t0">—</span><span class="t0">Night Owl Reviews Top Pick</span></p>
<p class="p2"><span class="t4">Out of the Gilded Cage</span></p>
<p class="p7"><span class="t0">“This is definitely a read now book.”</span></p>
<p class="p4"><span class="t0">—</span><span class="t0">MM Good Book Reviews</span></p>
<p class="p2"><span class="t4">Irish Winter</span></p>
<p class="p7">“This is a story that will stay with me because the essence of the times is captured and haunts me.”</p>
<p class="p8">—TwoLips Reviews</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002.vue?878d1a4c